import { render } from "./CreditoSimplePFComponent.vue?vue&type=template&id=3ec7ac90"
import script from "./CreditoSimplePFComponent.vue?vue&type=script&lang=js"
export * from "./CreditoSimplePFComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__